import { BigTitle, Body, MediaQueries, rem, SizedBox } from '@collabhouse/shared'
import React, { type FunctionComponent, type ReactChild } from 'react'
import styled from 'styled-components'

import { useBreadcrumbs } from '../../hooks/useBreadcrumbs'
import Breadcrumbs from '../breadcrumbs/Breadcrumbs'
import Grid, { GridItem } from '../grid/Grid'
import PaddedContainer from '../padded-container/PaddedContainer'

export interface OverviewPageTemplateProps {
  body?: ReactChild
  title?: ReactChild
}

const OverviewPageTemplate: FunctionComponent<React.PropsWithChildren<OverviewPageTemplateProps>> = ({
  title,
  body,
  children,
}) => {
  const { breadcrumbs } = useBreadcrumbs()

  return (
    <PaddedContainer>
      <Grid>
        <GridItem mobile={12}>
          <Header>
            <Breadcrumbs breadcrumbs={breadcrumbs} />
          </Header>
          {title && <BigTitle size="xSmall">{title}</BigTitle>}
          {title && body && <SizedBox height={rem(24)} />}
          {body && (
            <Grid>
              <GridItem desktop={6} mobile={12}>
                <Body size="large">{body}</Body>
              </GridItem>
            </Grid>
          )}
          {children}
        </GridItem>
      </Grid>
    </PaddedContainer>
  )
}

export default OverviewPageTemplate

const Header = styled.header`
  min-height: ${rem(40)};

  ${MediaQueries.desktop} {
    min-height: ${rem(68)};
  }
`
